import { partial } from '../../../util/translation/translation';

const p = partial('validateErrors.participantFormErrors');

const validateEmailInvite = (values) => {
  const errors = {};

  if (!values.email) {
    errors.email = p('emailFieldCantBeEmpty');
  }

  if (!values.guestAmount) {
    errors.guestAmount = p('numberOfGuestsFieldCantBeEmpty');
  }

  return errors;
};

export default validateEmailInvite;
